<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    @if (flight?.detail; as flightDetail) {
      @if (flightsToDisplay.detail.flights; as flights) {
        <div class="cart_item_heading">
          @for (
            flightDetail of flights;
            track flightDetail;
            let last = $last;
            let flightIndex = $index
          ) {
            <div [class.duplicate-item-wrapper]="duplicateBooking">
              @if (duplicateBooking) {
                <div class="duplicate-item-date">
                  <i class="ico-flight" aria-hidden="true"></i>&nbsp;
                  @if (!flightIndex) {
                    <span i18n="@@flightBasketDeparts">Departs:</span>
                  }
                  @if (flightIndex) {
                    <span i18n="@@flightBasketReturns">Returns:</span>
                  }
                  <strong>{{ flightDetail.dateTimeDeparting | sabsDate: 1 }}</strong>
                  <strong>{{ flightDetail.dateTimeDeparting | date: 'HH:mm' }}</strong>
                </div>
              }
              <div [class.duplicate-item-info]="duplicateBooking">
                <div class="airport-name-wrapper">
                  <span>
                    @if (!duplicateBooking) {
                      <i class="ico-flight" aria-hidden="true"></i>&nbsp;
                    }
                    <strong id="origin-airport-info-{{ flight.id }}-{{ flightIndex }}">{{
                      flightDetail.originAirportName
                    }}</strong
                    >&nbsp; <strong i18n="@@flilghtSearchTo">to</strong>&nbsp;
                    <strong>{{ flightDetail.destinationAirportName }}</strong>
                  </span>
                  @if (flightIndex === 0 && !duplicateBooking) {
                    <section (mouseleave)="tt1.close()">
                      <button
                        class="cart_item_remove ico-trash"
                        ngbTooltip="Remove {{ flightDescription }} from your {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        attr.aria-label="Remove {{ flightDetail.originAirportName }} to {{
                          flightDetail.destinationAirportName
                        }} flight from your {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        i18n-aria-label
                        i18n-ngbTooltip
                        (click)="remove.emit()"
                        triggers="manual"
                        #tt1="ngbTooltip"
                        (mouseenter)="tt1.open()"
                        (focus)="tt1.open()"
                        (blur)="tt1.close()"
                        id="remove-basketitem-{{ flight.id }}"
                      ></button>
                    </section>
                  }
                  @if (flightIndex === 0 && !duplicateBooking) {
                    <section (mouseleave)="tt2.close()">
                      <img
                        src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                          displayItinerary ? 'luggage_icon' : 'basket_move'
                        }}.svg"
                        class="move_basket_icon"
                        role="button"
                        ngbTooltip="Move to different {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        i18n-ngbTooltip
                        attr.aria-label="Move {{ flightDetail.originAirportName }} to {{
                          flightDetail.destinationAirportName
                        }} flight to different {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        i18n-aria-label
                        (click)="openChangeModal.emit()"
                        (keydown.enter)="openChangeModal.emit()"
                        (keydown.space)="openChangeModal.emit()"
                        triggers="manual"
                        #tt2="ngbTooltip"
                        (mouseenter)="tt2.open()"
                        (focus)="tt2.open()"
                        (blur)="tt2.close()"
                        tabindex="0"
                        id="share-basketitem-{{ flight.id }}"
                      />
                    </section>
                  }
                </div>
                <div class="car_cart_item_from_point">
                  @if (!duplicateBooking) {
                    <span i18n="@@itineraryDepart">Depart:</span>
                    {{ flightDetail.dateTimeDeparting | sabsDate: 5 }}
                    <br />
                    <span i18n="@@itineraryArrive">Arrives:</span>
                    {{ flightDetail.dateTimeArriving | sabsDate: 5 }}
                    <br />
                    <span id="terminal-info-origin-airport-{{ flight.id }}" class="terminal-span">
                      <span i18n="@@flightLegsTerminalDep">Terminal:</span>
                      <span>
                        {{
                          (flightDetail.originTerminal
                            ? flightDetail.originTerminal
                            : 'not available'
                          ) | translate
                        }}</span
                      >
                    </span>
                    <br />
                    <span id="terminal-info-dest-airport-{{ flight.id }}" class="terminal-span">
                      <span i18n="@@flightLegsTerminalArr">Destination terminal:</span>
                      <span>
                        {{
                          (flightDetail.destinationTerminal
                            ? flightDetail.destinationTerminal
                            : 'not available'
                          ) | translate
                        }}</span
                      >
                    </span>
                    <br />
                  }
                  <span i18n="@@pnlSearchFlightNumber">Flight number:</span>
                  <span
                    >{{ flightDetail.marketingCarrier
                    }}{{ flightDetail.marketingFlightNumber }}</span
                  >
                  <br />
                  <span i18n="@@basketPanelOperatedByRail">Operated by:</span>
                  <span>{{ flightDetail.operatingCarrierName }}</span>
                  <br />
                  <span i18n="@@itineraryRailTicketDescription">Ticket:</span>
                  {{
                    flightDetail.additional?.mixedCabinClass || flightDetail.cabinClass
                      | splitCamelCase
                      | translate
                  }}
                  @if (
                    flightDetail.additional?.fareBrand?.name &&
                    !flightDetail.additional?.mixedCabinClass
                  ) {
                    <span> ({{ flightDetail.additional.fareBrand.name | titlecase }})</span>
                  }
                  @if (!duplicateBooking) {
                    <section class="container" (mouseleave)="ttFareRules.close()">
                      <a
                        tabindex="0"
                        (click)="getFareRules(flightIndex)"
                        (keydown.enter)="getFareRules(flightIndex); $event.stopPropagation()"
                        role="link"
                        class="fare_rules_link"
                        attr.aria-label="Fare rules for {{
                          flightDetail.destinationAirportName
                        }} ({{ flightIndex + 1 }})"
                        ngbTooltip="Fare rules"
                        i18n-ngbTooltip
                        triggers="manual"
                        #ttFareRules="ngbTooltip"
                        (mouseenter)="ttFareRules.open()"
                        (focus)="ttFareRules.open()"
                        (blur)="ttFareRules.close()"
                        ><i class="currency_info_icon"></i
                        ><span class="visuallyhidden" i18n="@@flightBasketFareRules"
                          >Fare Rules</span
                        ></a
                      >
                    </section>
                  }
                  <app-erm-traveller
                    [joinerOrLeaver]="flight?.searchQuery?.joinerOrLeaver"
                  ></app-erm-traveller>
                </div>
                @if (!duplicateBooking) {
                  <div class="car_cart_item_to_point" [ngClass]="{ final: last }">
                    <div class="resolve_loader_container" hidden="">
                      <div class="resolve_loader_loading_container">
                        <app-loading-spinner size="sm" /><span
                          tabindex="0"
                          aria-atomic="true"
                          aria-live="assertive"
                          i18n="@@flightBasketGettingFareRules"
                          class="resolve_loader_text"
                          >Getting Fare Rules...</span
                        >
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <app-ndc-fare-link
            [serviceName]="flight?.service?.name"
            [additionalClass]="'fare-rules-link-text'"
          ></app-ndc-fare-link>
          @for (user of travellers; track user; let index = $index) {
            @if (extras.length && !duplicateBooking) {
              <div class="pax-extras">
                <b>{{ user.forename }}, {{ user.surname }}</b>
                @if (
                  extras[index].seatsOutbound.seats && extras[index].seatsOutbound.seats;
                  as seats
                ) {
                  <div>
                    @if (seats?.seat) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span i18n="@@flightBasketOutboundSeat">Outbound seat</span
                          ><span>{{ seats.seat }}</span>
                        </div>
                        {{ seats.price | currency: seats.currency }}
                      </div>
                    }
                  </div>
                }
                @if (
                  isTFX && extras[index].seatsInbound.seats && extras[index].seatsInbound.seats;
                  as seats
                ) {
                  <div>
                    @if (seats?.seat) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span i18n="@@flightBasketInboundSeat">Inbound seat</span
                          ><span>{{ seats.seat }}</span>
                        </div>
                        {{ seats.price | currency: seats.currency }}
                      </div>
                    }
                  </div>
                }
                @for (extra of extras; track extra) {
                  <div>
                    <!-- additionalOutbound -->
                    @if (
                      user.id === extra.additionalOutbound?.advancedAncillaryOptions?.userId &&
                        extra.additionalOutbound?.advancedAncillaryOptions;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                    @if (
                      user.id === extra.additionalOutbound?.baggageAllowance?.userId &&
                        extra.additionalOutbound?.baggageAllowance;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                    @if (
                      user.id === extra.additionalOutbound?.flightExtras?.userId &&
                        extra.additionalOutbound?.flightExtras;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                    @if (
                      user.id === extra.additionalOutbound?.reducedMobillityAssistance?.userId &&
                        extra.additionalOutbound?.reducedMobillityAssistance;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                  </div>
                }
                <!-- additionalInbound -->
                @if (
                  !isTFX && extras[index].seatsInbound.seats && extras[index].seatsInbound.seats;
                  as seats
                ) {
                  <div>
                    @if (seats?.seat) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span i18n="@@flightBasketInboundSeat">Inbound seat</span
                          ><span>{{ seats.seat }}</span>
                        </div>
                        {{ seats.price | currency: seats.currency }}
                      </div>
                    }
                  </div>
                }
                @for (extra of extras; track extra) {
                  <div>
                    @if (
                      user.id === extra.additionalInbound?.advancedAncillaryOptions?.userId &&
                        extra.additionalInbound?.advancedAncillaryOptions;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                    @if (
                      user.id === extra.additionalInbound?.baggageAllowance?.userId &&
                        extra.additionalInbound?.baggageAllowance;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                    @if (
                      user.id === extra.additionalInbound?.flightExtras?.userId &&
                        extra.additionalInbound?.flightExtras;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                    @if (
                      user.id === extra.additionalInbound?.reducedMobillityAssistance?.userId &&
                        extra.additionalInbound?.reducedMobillityAssistance;
                      as item
                    ) {
                      <div class="flex-row-container space-between">
                        <div>
                          <span>{{ item.text }}</span>
                        </div>
                        {{ item.price | currency: item.currency }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          }
          @if (hasSeats && !duplicateBooking) {
            <div>
              <span i18n="@@editSeats">Edit Seats and Extras</span>
              <section (mouseleave)="tt3.close()">
                <button
                  class="edit_seats_button"
                  id="editFlightSeat"
                  [ngbTooltip]="!disableEditButton ? 'Edit Seat Selection' : null"
                  aria-label="Edit selected Seat Selection"
                  i18n-ngbTooltip
                  [disabled]="disableEditButton"
                  [ngClass]="{ disableEditButton: disableEditButton }"
                  placement="right"
                  (click)="openSeatMapModal()"
                  triggers="manual"
                  #tt3="ngbTooltip"
                  (mouseenter)="tt3.open()"
                  (focus)="tt3.open()"
                  (blur)="tt3.close()"
                >
                  <i class="ico-edit" aria-hidden="true"></i>
                </button>
              </section>
              @if (hasSeats && disableEditButton) {
                <section (mouseleave)="tt.close()" class="container">
                  <i
                    class="ico ico-info-circle info-button"
                    i18n-ngbTooltip
                    ngbTooltip="Seat and extra selections can no longer be edited. To make changes, please remove this flight and add it again to select new options"
                    aria-label="Seat and extra selections can no longer be edited. To make changes, please remove this flight and add it again to select new options"
                    triggers="manual"
                    #tt="ngbTooltip"
                    (mouseenter)="tt.open()"
                    (focus)="tt.open()"
                    (blur)="tt.close()"
                    tabindex="0"
                    ><span class="visuallyhidden"
                      >Seat and extra selections can no longer be edited. To make changes, please
                      remove this flight and add it again to select new options</span
                    >
                  </i>
                </section>
              }
            </div>
          }
        </div>
      }
      <div class="cart_item_price">
        @if (duplicateBooking) {
          <strong i18n="@@flightBasketCost">Cost</strong>
        }
        <strong>{{ flight.price | currency: flight.currency }}</strong>
        @if (!duplicateBooking) {
          <em i18n="@@totalPrice"> Total Price </em>
        }
      </div>
    }
  </div>
</div>
